import React, { useRef, useState } from "react";
import { formatDate } from "../../_App/Helpers/helpers";
import { useTranslation } from "react-i18next";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import {
  findUserNombreLivraisonApi,
  findUsersByCodeApi,
} from "../../_App/Redux/Slices/users/userSlice";
import { Spinner, Table, Button } from "react-bootstrap";
import BonTransfert from "./files/BonTransfert";

export default function NombreLivraison() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [userlivraison, setuserlivraison] = useState<any>(" ");
  const lastKeyPressTime = useRef<number>(0);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();
  const [loading, setLoading] = useState(false);
  const [listTransfert, setListTransfert] = useState<any[]>([]);
  const [showBon, setShowBon] = useState(false);
  const [dataBon, setDataBon] = useState<any>(null);
  const [nombreLivraison, setNombreLivraison] = useState<number>(0);
  const societe_id = useAppSelector(societeId);
  const userRef = useRef<HTMLInputElement | null>(null);

  const today = new Date();
  const lastMonth = new Date(today);
  lastMonth.setMonth(today.getMonth() - 1);
  const [filters, setFilters] = useState({
    dateDebut: formatDate(lastMonth),
    dateFin: formatDate(today),
  });

  // 🧭 Gestion des filtres date
  const handleFilterChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔍 Recherche d’un agent par code
  const handleChangeAgentLivraison = async (e: any) => {
    const value = e.target.value;
    const now = Date.now();
    if (value === "") {
      setuserlivraison(" ");
    } else {
      setuserlivraison(value);
    }
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    const isScannerInput = timeDiff < 50;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(
      async () => {
        if (value !== "") {
          const data = { societe: societe_id, code: value };
          setLoading(true);
          const result = await dispatch(findUsersByCodeApi(data));
          if (result.payload.success) {
            setuserlivraison(result.payload.data);
          } else {
            ToastWarning(result.payload.message);
            setuserlivraison(" ");
          }
          setLoading(false);
        }
      },
      isScannerInput ? 100 : 1500
    );

    setTimeoutId(newTimeoutId);
  };

  const removeAgentlivraison = () => {
    setuserlivraison(" ");
    setListTransfert([]);
    setNombreLivraison(0);
    setTimeout(() => {
      userRef.current?.focus();
    }, 0);
  };

  // 🚚 Trouver les livraisons de l’agent
  const findTransfertLivreur = async () => {
    if (
      userlivraison &&
      userlivraison.code &&
      filters.dateDebut &&
      filters.dateFin
    ) {
      setLoading(true);
      const result = await dispatch(
        findUserNombreLivraisonApi({
          id: userlivraison._id,
          dateDebut: filters.dateDebut,
          dateFin: filters.dateFin,
        })
      );

      if (result.payload.success) {
        setListTransfert(result.payload.data.listTransfer);
        setNombreLivraison(result.payload.data.nombre);
      } else {
        ToastWarning(t("Aucun transfert trouvé"));
        setListTransfert([]);
        setNombreLivraison(0);
      }
      setLoading(false);
    } else {
      ToastWarning(t("Veuillez sélectionner un agent et une période"));
    }
  };

  return (
    <div className="row layout-spacing">
      <div className="col-lg-12 bg-white p-3 rounded">
        <h2 className="mb-4">🚚 {t("Nombre de livraisons par agent")}</h2>

        {/* 🔍 Filtres */}
        <div className="row bg-light p-3 rounded align-items-end">
          <div className="col-md-3">
            <label>{t("Agent de livraison : ")}</label>
            {userlivraison && typeof userlivraison === "string" ? (
              <input
                type="text"
                className="form-control"
                onChange={(e) => handleChangeAgentLivraison(e)}
                value={userlivraison}
                ref={userRef}
              />
            ) : (
              <div className="d-flex align-items-center">
                <span className="form-control">
                  {userlivraison?.nom + " " + userlivraison?.prenom}
                </span>
                <i
                  onClick={removeAgentlivraison}
                  className="fas fa-times ms-2 text-danger"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            )}
          </div>

          <div className="col-md-3">
            <label>{t("Date début")}</label>
            <input
              type="date"
              name="dateDebut"
              className="form-control"
              value={filters.dateDebut}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-md-3">
            <label>{t("Date fin")}</label>
            <input
              type="date"
              name="dateFin"
              className="form-control"
              value={filters.dateFin}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-md-2">
            <Button
              variant="primary"
              className="w-100"
              onClick={findTransfertLivreur}
              disabled={loading}
            >
              {loading ? <Spinner size="sm" /> : <>{t("Rechercher")}</>}
            </Button>
          </div>
        </div>

        {/* 📊 Résultats */}
        {listTransfert.length > 0 && (
          <div className="mt-4">
            <h5>
              {t("Nombre total de livraisons : ")}{" "}
              <strong>{nombreLivraison}</strong>
            </h5>

            <Table  bordered hover responsive className="mt-3">
              <thead >
                <tr>
                  <th>#</th>
                  <th>{t("Date")}</th>
                  <th>{t("Référence")}</th>
                  <th>{t("Organisation demande")}</th>
                  <th>{t("Organisation transfert")}</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {listTransfert.map((tr: any, index: number) => (
                  <tr key={tr._id || index}>
                    <td>{index + 1}</td>
                    <td>{formatDate(new Date(tr.createdAt))}</td>
                    <td>{tr.NumBonreception}</td>
                    <td>{tr.organisation_demande?.nom}</td>
                    <td>{tr.organisation_transfer?.nom}</td>
                    <td>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          setDataBon(tr);
                          setShowBon(true);
                        }}
                      >
                        <i className="fas fa-eye"></i> {t("Voir bon")}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        {/* 📄 Bon de transfert */}
        {showBon && (
          <BonTransfert
            societeid={societe_id}
            datainfo={dataBon}
            type="reception"
            setshowbon={setShowBon}
            ShowBon={showBon}
            t={t}
          />
        )}
      </div>
    </div>
  );
}
